import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export const Fact: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <Stack gap={0.5} minWidth={0}>
    <Typography variant="body2" color="text.secondary" noWrap>
      {label}
    </Typography>
    <Box>{children}</Box>
  </Stack>
);

export const Row: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <Box
    sx={(theme) => ({
      display: 'grid',
      gap: { xs: 0.5, sm: 1.5 },
      gridTemplateColumns: { xs: '1fr', sm: '9rem minmax(0, 1fr)' },
      alignItems: 'baseline',
      py: 1.25,
      borderBottom: `1px solid ${theme.palette.background.divider}`,
      '&:last-of-type': { borderBottom: 'none' },
    })}
  >
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Box minWidth={0}>{children}</Box>
  </Box>
);
